import axios, { AxiosPromise } from 'axios';
import { DeviceRequest } from '../sic-lib/types/DeviceRequest';
import { UserConfigResponse } from '../sic-lib/types/UserConfig';
import { apiInstance as instance } from './';

let requestUserConfig_cancel: any;

export function requestUserConfig(): AxiosPromise<UserConfigResponse> {
    if (requestUserConfig_cancel) requestUserConfig_cancel();

    return instance.post(
        '/config',
        {},
        {
            cancelToken: new axios.CancelToken(function executor(c) {
                requestUserConfig_cancel = c;
            }),
        },
    );
}

let requestTwilioConfig_cancel: any;

export function requestTwilioConfig(): AxiosPromise<{ token: string }> {
    if (requestTwilioConfig_cancel) requestTwilioConfig_cancel();

    return instance.get('/config/calltoken?platform=web', {
        cancelToken: new axios.CancelToken(function executor(c) {
            requestTwilioConfig_cancel = c;
        }),
    });
}

let requestRegisterDevice_cancel: any;

export function requestRegisterDevice(data: DeviceRequest): AxiosPromise<unknown> {
    if (requestRegisterDevice_cancel) requestRegisterDevice_cancel();

    return instance.put('/config/devices', data, {
        cancelToken: new axios.CancelToken(function executor(c) {
            requestRegisterDevice_cancel = c;
        }),
    });
}

export function activateSiC(): AxiosPromise<unknown> {
    return instance.post('/config/activate');
}
